<script>
    import ConfirmationDialog from "../dialogs/ConfirmationDialog.svelte";
    import { toolkitEndPointUrl } from "../../stores/AppConfig";

    import IconButton, { Icon } from '@smui/icon-button';

    //import { push } from "svelte-spa-router";
    import { _ } from 'svelte-i18n';

    let dialogOpen = false;

</script>

<IconButton class="white-text menu-btn"
            title="{$_('home')}"
            ripple={false}
            on:click="{() => {
                dialogOpen = true;
            }}">
    <Icon tag='svg'
        viewBox="0 0 24 24"
        class="home-icon">
        <path fill="none" stroke="currentColor" d="M10 1.5L1.5 8.25V20.5h6v-8h5v8h6V8.25z" />
    </Icon>
</IconButton>

<ConfirmationDialog
    open={dialogOpen}
    title={$_("exit_application")}
    noBtnText={$_("no")}
    yesBtnText={$_("yes")}
    big={false}
    headerColors="tescoblue white-text"
    on:reject={() => {
        dialogOpen = false;
    }}
    on:confirm={() => {
        dialogOpen = false;
        window.location.href=($toolkitEndPointUrl);
    }}
>
    {$_("do_you_want_to_exit_application")}
    <br>
    <br>
    {$_("unsaved_changes_will_be_lost")}
</ConfirmationDialog>
